export default __webpack_public_path__ + "static/media/powered_by_capstone@2x.ce942851.png";